import { render } from "./MyTeamsView.vue?vue&type=template&id=10587582&scoped=true"
import script from "./MyTeamsView.vue?vue&type=script&lang=js"
export * from "./MyTeamsView.vue?vue&type=script&lang=js"

import "./MyTeamsView.vue?vue&type=style&index=0&id=10587582&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10587582"]])

export default __exports__